import JsFileDownloader from "js-file-downloader";

const DOWNLOAD_TIMEOUT_MS = 1200000; // 20 minutes

interface DownloadFileParams {
  url: string;
  filename: string;
  onProgress?: (percent: number) => void;
}

export default function downloadFile({
  url,
  filename,
  onProgress,
}: DownloadFileParams) {
  return new JsFileDownloader({
    url,
    filename,
    timeout: DOWNLOAD_TIMEOUT_MS,
    process: (event) => {
      if (!event.lengthComputable || !onProgress) return;
      onProgress(Math.floor((event.loaded / event.total) * 100));
    },
  });
}
